import { Contato } from '../../types';
import ServiceCard from './ServiceCard';
import * as S from './styles';

interface Props {
  contatos: Contato[];
  onSelect: (contato: Contato) => void;
}

function Services({ contatos, onSelect }: Props) {
  return (
    <S.ServicesSection id="atendimento">
      <S.ServicesGrid>
        {contatos.map((contato) => (
          <ServiceCard
            key={`${contato.tipoContatoId}-${contato.descricao}`}
            contato={contato}
            onSelect={onSelect}
          />
        ))}
      </S.ServicesGrid>
    </S.ServicesSection>
  );
}

export default Services;
